<div class="c-active-filters"
   [ngClass]="[
      activeFiltersHeight===ActiveFiltersHeightTypeEnum.EXPANDED ? 'c-active-filters--active-filters-height-expanded' : '',
      isReport && activeFiltersHeight===ActiveFiltersHeightTypeEnum.EXPANDED ? 'c-active-filters-report-content-height-expanded' : '',
      ]">
    <div class="c-active-filters__active-filters-wrapper">
      <ng-container *ngIf="!isReport && activeFiltersGroups?.length">
        <form [formGroup]="form">
          <ng-container [formArrayName]="'activeFilters'">
            <ng-container *ngFor="let filterFormGroup of activeFiltersGroups; index as i">
              <ng-container [formGroup]="filterFormGroup"> <!-- *ngIf="isFormGroupValid(filterFormGroup)" -->
                <div class="c-active-filters__filter-item">
                  <div class="c-active-filters__field-value cell auto">
                    <div [class.field-disabled]="disableValueInput(filterFormGroup.controls['operation'].value)">
                      <app-field-edit
                        *ngIf="filterFormGroup.controls['fieldName'].value && getField(filterFormGroup.controls['fieldName'].value); else defaultFilterInput"
                        [label]="createFieldLabel(filterFormGroup)"
                        [field]="getField(filterFormGroup.controls['fieldName'].value)"
                        [controlName]="'value'"
                        [filter]="getField(filterFormGroup.controls['fieldName'].value)?.filters"
                        [allowTextAsValue]="getField(filterFormGroup.controls['fieldName'].value).allowTextAsValue"
                        (keyup.enter)="onKeyupEnter(getField(filterFormGroup.controls['fieldName'].value))">
                      </app-field-edit>
                      <ng-template #defaultFilterInput>
                        <app-input-text
                          [formControlName]="'value'"
                          [label]="createFieldLabel(filterFormGroup)"
                          [isFullWide]="true">
                        </app-input-text>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </form>
      </ng-container>
      <ng-container *ngIf="isReport">
        <ng-content></ng-content>
      </ng-container>
      <div class="c-active-filters__active-filters--arrows" (click)="toggleFiltersHeight()"
      [ngClass]="isReport ? 'c-active-filters__active-filters--arrows-report' : ''">
        <app-bui-button-icon
          *ngIf="activeFiltersHeight === ActiveFiltersHeightTypeEnum.COLLAPSED"
          [iconName]="'chevron-double-down'"
          [iconSize]="'small'"
          [contentColor]="'dark'"
          [backgroundStyle]="'medium'"
          [borderStyle]="'dark'">
        </app-bui-button-icon>
         <app-bui-button-icon
           *ngIf="activeFiltersHeight === ActiveFiltersHeightTypeEnum.EXPANDED"
           [iconName]="'chevron-double-up'"
           [iconSize]="'small'"
           [contentColor]="'dark'"
           [backgroundStyle]="'medium'"
           [borderStyle]="'dark'">
        </app-bui-button-icon>
      </div>
    </div>
</div>
